import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { OrderType } from '@synergy/models';
import { PoolSelect, SelectOption, useFilter } from '@synergy/components';

const salesOrderTypeOptions: SelectOption[] = Object.keys(OrderType).map(key => {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        value: (OrderType as any)[key],
        displayValue: <FormattedMessage id={'app.orderType.' + key.toLowerCase()} />,
    };
});

export const SalesOrderTypeFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (value?: string) => {
        filter.delete(FilterParams.OrderType);
        if (value) {
            filter.set(FilterParams.OrderType, value);
        }
        updateFilter(filter);
    };

    registerFilterMap(FilterParams.OrderType, typeValue => {
        const type = salesOrderTypeOptions.find(option => option.value === typeValue);
        return type?.displayValue;
    });

    return (
        <PoolSelect
            displayEmpty={true}
            name="type"
            label={<FormattedMessage id="app.table.column.type" />}
            fullWidth={true}
            value={filter.get(FilterParams.OrderType)}
            onValueChange={onSelected}
            options={salesOrderTypeOptions}
            noSorting={true}
        />
    );
};
